import styled, { css } from 'styled-components';

export default styled.div`
  ${({ vh }) => css`
    display: flex;
    flex-direction: column;
    position: relative;
    min-height: ${`calc(${vh}px * 100)`};
    justify-content: space-between;
`}
`; 
